import * as React from 'react';
import './itemArchiveModal.scss';
import { Modal } from 'rcd-cpp-ui/ui/modal/Modal';
import { Metadata } from '../../types';
import { getToken } from '../../utils/authClient';
import { useActions } from '../View/viewActions';
import { useSelector } from '../../utils/useSelector';
import { getSchema } from '../../utils';
import { NodeType } from '../../enums/NodeType';
import { getAdditionalInfo } from '../ItemKeepActiveModal/itemKeepActiveModal';

export interface ArchiveRequestCallbackParams {
  itemId: number;
  expiryRequestByName: string;
  expiryRequestByRefId: string;
  expiryRequestJustification?: string;
  expiryRequestType?: string;
}

type Props = {
  onCancel: () => any;
  data: Partial<Metadata>;
};

export const ItemArchiveModal = ({ onCancel, data }: Props) => {
  const coeDisplayField = useSelector(
    s =>
      getSchema(
        s.planning?.selectedWorkspace?.schemas,
        NodeType.MaintenanceCOEProposal
      )?.props?.displayField
  );
  const { updateExpiryView } = useActions();
  const cppArchive = React.useRef<any>(null);
  const onDone = (params: ArchiveRequestCallbackParams) => {
    onCancel();
    updateExpiryView(params);
  };

  React.useEffect(() => {
    if (cppArchive.current) {
      cppArchive.current.getToken = getToken;
      cppArchive.current.onDone = onDone as any;
      cppArchive.current.onCancel = onCancel;
      (cppArchive.current as any).getAdditionalInfo = getAdditionalInfo(
        coeDisplayField,
        data
      );
    }
  }, []);

  return (
    <Modal
      header="Archive"
      id="itemArchiveModal"
      onClose={onCancel}
      height="500px"
      width="750px"
    >
      <cpp-item-archive
        ref={cppArchive}
        id="cppArchive"
        itemId={data.props.itemId}
      ></cpp-item-archive>
    </Modal>
  );
};
